import Plugin from './plugin.js';
import { logInfo, logError } from './log.js';
import { isMobile } from './validate.js';
import { select, selectAll } from './query.js';
import { emit, on } from './event.js';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

const _Page = {
	getSettingByCtx(ctx) {
		return {
			name: ctx.name || 'page',
			init: function () {
				logInfo('initing');
				Object.assign(ctx, _Page.initCtxByWindow(ctx));
				Object.assign(ctx, _Page.initCtxByUa(ctx));
				Object.assign(ctx, _Page.initCtxByUrl(ctx));
				Object.assign(ctx, _Page.initCtxByCookie(ctx));
				Object.assign(ctx, _Page.initCtxByStorage(ctx));
				return ctx;
			},
			load: function () {
				logInfo('loading');
				return new Promise((resolve) => {
					if (ctx.data) {
						return resolve(ctx.data);
					}
					try {
						let data = {};
						Object.assign(ctx, data);
						return resolve(data);
					} catch (e) {
						logError(e);
						return resolve({});
					}
				});
			},
			render: function () {
				// _Page.renderComponent();
				_Page.eventListener();
				emit('dom.load');
			},
		};
	},
	getScrollTop() {
		return window.pageYOffset || document.documentElement.scrollTop;
	},
	isLandscape() {
		return _Page.width > _Page.height;
	},
	getHeight() {
		return window.innerHeight;
	},
	getWidth() {
		return window.innerWidth;
	},
	inputing() {
		let tagName = document.activeElement ? document.activeElement.tagName : '';
		return ['TEXTAREA', 'INPUT', 'SELECT'].indexOf(tagName) > -1;
	},
	init: null,
	width: null,
	height: null,
	landscape: null,
	scrollTop: null,
	originalScrollTop: null,
	onResize() {
		_Page.updatePageInfo();
		if (_Page.landscape) {
			select('body').classList.add('landscape');
			select('body').classList.remove('portrait');
		} else {
			select('body').classList.add('portrait');
			select('body').classList.remove('landscape');
		}
		emit('dom.resize');
	},
	onScroll() {
		_Page.originalScrollTop = _Page.scrollTop;
		_Page.scrollTop = _Page.getScrollTop();
		if (_Page.scrollTop > _Page.originalScrollTop) {
			_Page.isScrollDown = true;
		} else {
			_Page.isScrollDown = false;
		}
		if (_Page.isScrollDown) {
			select('body').classList.add('scroll-down');
		} else {
			select('body').classList.remove('scroll-down');
		}
		emit('dom.scroll');
	},
	updatePageInfo() {
		_Page.width = _Page.getWidth();
		_Page.height = _Page.getHeight();
		_Page.scrollTop = _Page.getScrollTop();
		_Page.landscape = _Page.isLandscape();
	},
	initCtxByWindow() {
		_Page.updatePageInfo();
		return {
			isLandscape: _Page.height,
			scrollTop: _Page.width,
			height: _Page.height,
			width: _Page.getWidth(),
		};
	},
	initCtxByUa(ctx) {
		logInfo('initCtxByUa');
		let dataFromUa = {};
		if (ctx.isMobile === undefined) {
			dataFromUa.isMobile = isMobile(window.navigator.userAgent);
		}
		return dataFromUa;
	},
	initCtxByUrl() {
		logInfo('initCtxByUrl');
		let dataFromUrl = {};
		return dataFromUrl;
	},
	initCtxByCookie() {
		logInfo('initCtxByCookie');
		let dataFromCookie = {};
		return dataFromCookie;
	},
	initCtxByStorage() {
		logInfo('initCtxByStorage');
		let dataFromStorage = {};
		return dataFromStorage;
	},
	eventListener() {
		logInfo('add event for renderComponent');
		on(
			'dom.load',
			throttle(() => {
				// the interface wil be follow ARIA which is nice for more accessibility
				selectAll('[data-role]').forEach((item) => {
					if (item.hasAttribute('loaded')) {
						return;
					}
					let data = item.dataset;
					let types = data.role;
					if (!types) {
						return;
					}
					item.setAttribute('loaded', true);
					types = types.trim(' ').split(/\s+/g);
					types.forEach((type) => {
						let plugin = Plugin.getPlugin(type);
						if (plugin) {
							item.dataset[type] = plugin(item, data);
						}
					});
				});
			}),
		);
		window.addEventListener(
			'resize',
			debounce(() => {
				if (!_Page.inputing()) {
					_Page.onResize();
				}
			}, 100),
		);
		window.addEventListener(
			'scroll',
			debounce(() => {
				_Page.onScroll();
			}, 100),
		);
	},
};
class Page extends Plugin {
	constructor(ctx) {
		if (!ctx) {
			logError('ctx is required');
		}
		let setting = _Page.getSettingByCtx(ctx);
		super(setting, 'page');
		this.ctx = ctx;
	}
}
Page.getPlugin = _Page.getPlugin;
export default Page;
